<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useAccessDisplayNames, useAuth } from '#layers/access/public';
import { useSettingsOverlay } from '#layers/global-settings/public';

const { currentUser } = storeToRefs(useAuth());
const { getUserDisplayName } = useAccessDisplayNames();
const { open, isOpen } = useSettingsOverlay();
</script>

<template>
	<DTooltip
		v-if="currentUser"
		ignore-non-keyboard-focus
		:disabled="isOpen"
		:content="{ side: 'right', sideOffset: 8 }"
		:ui="{ content: 'h-auto flex-col items-start gap-0' }"
	>
		<template #content>
			<span class="text-sm font-semibold">{{ getUserDisplayName(currentUser) }}</span>
			<span v-if="currentUser.fullName" class="text-xs">{{ currentUser.email }}</span>
		</template>

		<button
			type="button"
			data-testid="user-settings-button"
			class="
				flex size-8 cursor-pointer items-center justify-center rounded-full
				focus-visible:ring-2 focus-visible:ring-(--ui-border-focused) focus-visible:outline-none
			"
			:aria-label="getUserDisplayName(currentUser)"
			@click="open('account/profile')"
		>
			<UserAvatar :user="currentUser" class="size-8" />
		</button>
	</DTooltip>
</template>
